import { GridDateTime } from '@/components/modules/_shared/utils/DataGridFields/GridDateTime';
import { Text } from '@/components/shared/components/Text';

export const createdAtFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.45,
    field: 'created_at',
    headerName: <Text tId={'CREATION_DATE'} />,
    align: 'right',
    type: 'number',
    searchable: false,
    defaultSort: 'desc',
    renderCell: (rowData) => {
      return <GridDateTime value={rowData.row.createdAt} />;
    },
  };
};
